import type { NetworkOptions } from "@product/scmp-sdk/dist/types/lib/relay/network";
import type { FastifyRequest } from "fastify";
import type { IncomingMessage } from "http";
import setCookieParser from "set-cookie-parser";

import { config } from "~/data";
import { SCMPAccessTokenCookiesKey } from "~/lib/account";
import { isSsr } from "~/lib/utils";

export const createNetworkOptions = ({
  cookies = {},
  credentials,
}: {
  cookies?: FastifyRequest["cookies"];
  credentials: NetworkOptions["urlOptions"]["credentials"];
}): NetworkOptions => ({
  authOptions: {
    allowEmptyToken: true,
    token: _ => cookies[SCMPAccessTokenCookiesKey] ?? "",
    async tokenRefreshPromise() {
      if (isSsr()) return "";
      const { refreshToken } = await import("~/lib/account");
      const response = await refreshToken();
      if (!response) return "";
      const cookies = setCookieParser.parse(response as unknown as IncomingMessage);
      return cookies.find(cookie => cookie.name === SCMPAccessTokenCookiesKey)?.value ?? "";
    },
  },
  urlOptions: {
    credentials,
    headers: {
      apikey: config.graphql.contentService.apiKey,
    },
    method: "POST",
    url: config.graphql.contentService.host,
  },
});
